// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router.js'
import VModal from 'vue-js-modal'
import smoothScroll from 'vue-smoothscroll'
Vue.use(VModal)
Vue.use(smoothScroll)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js